export default __webpack_public_path__ + "static/HomeVisitKitchen-fa7c048a4d6b09c21e673eddc5ea8307.png";